module.exports = __webpack_public_path__ + "media/images/map-img-48e28c324c1e0d45a59a9e7b36d8b737.jpg";